var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14.58 11.86C14.58 10.61 15.59 9.6 16.84 9.6C18.09 9.6 19.1 10.61 19.1 11.86V16.39C19.1 21.39 15.05 25.45 10.04 25.45C5.03 25.45 1 21.39 1 16.39V6.88C1 5.63 2.01 4.62 3.26 4.62C4.51 4.62 5.52 5.63 5.52 6.88V3.26C5.52 2.01 6.53 1 7.78 1C9.03 1 10.04 2.01 10.04 3.26V5.07C10.04 3.82 11.05 2.81 12.3 2.81C13.55 2.81 14.56 3.82 14.56 5.07V11.86H14.58Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 5.07006C10.0508 3.82006 11.0608 2.81006 12.3108 2.81006C13.5608 2.81006 14.5708 3.82006 14.5708 5.07006V11.8601",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51953 6.88V3.26C5.51953 2.01 6.52953 1 7.77953 1C9.02953 1 10.0395 2.01 10.0395 3.26V10.96",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 18.6501C10.05 16.1501 12.08 14.1201 14.58 14.1201V11.8601C14.58 10.6101 15.59 9.60012 16.84 9.60012C18.09 9.60012 19.1 10.6101 19.1 11.8601V16.3901C19.1 21.3901 15.05 25.4501 10.04 25.4501C5.03 25.4501 1 21.3901 1 16.3901V6.88012C1 5.63012 2.01 4.62012 3.26 4.62012C4.51 4.62012 5.52 5.63012 5.52 6.88012V11.8601",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.da0d4aea45410317f8a400be2cfef967.svg";
export { ForwardRef as ReactComponent };